export const CLEAR_AUDIO = 'CLEAR_AUDIO'
export const CLEAR_AUDIO_ADS = 'CLEAR_AUDIO_ADS'
export const SET_AUDIO = 'SET_AUDIO'
export const SET_AUDIO_CAMPAIGNS = 'SET_AUDIO_CAMPAIGNS'
export const SET_AUDIO_ADS = 'SET_AUDIO_ADS'
